import $ from 'jquery';

import {
	inArray,
	getDOMElements
} from '../common/utilities.js';

// Import utilities
const {
	isDefined,
	isEmpty
} = _uo.utility;

import {
	fieldTypes as validFieldTypes
} from '@builder-legacy/config/valid-data';

/**
 * Validate form using the global object UncannyAutomator.recipe, which contains
 * all the recipe items 
 *
 * @since 0.3
 *
 * @return {object}
 * @return {boolean}  response.canSubmit - TRUE if the recipe is valid
 */

export function validateRecipe(){
	// Set response object
	let response = {
		canSubmit: UncannyAutomator.recipe.isValid
	}
	
	// Check if the recipe is not valid
	if ( ! UncannyAutomator.recipe.isValid ){

		// Enable error mode
		// UncannyAutomator.recipe.errorMode = true;

		// Iterate each item
		$.each( UncannyAutomator.recipe.items, function( itemID, itemData ){

			// Validate each item
			validateItem( itemID );
		});
	}

	return response;
}

/**
 * Validate item using the itemID
 *
 * @since 0.4
 *
 * @param  {int} 	  itemID - ID of the item
 * @param  {object}   [$item] - jQuery object of the item. Necessary only if itemID is undefined
 *
 * @return {object}
 * @return {boolean}  response.isValid - TRUE if the item is valid
 */

export function validateItem( itemID, $item = null ){
	// Create response object
	let response = {
		isValid: false
	}

	// Check if the itemID is defined
	if ( isDefined( itemID ) ){
		// Get item
		let item = UncannyAutomator.recipe.items[ itemID ];

		// Check if the item exists, otherwise do nothing, isValid will be false (because of the default value)
		if ( ! item.isMissing && ! isEmpty( item ) ){
			// Save result
			response.isValid = item.isValid;

			// Check if this item is invalid
			if ( ! item.isValid ){

				// Get DOM element of the item
				let itemElement = getDOMElements( 'item', {
					id: itemID
				}).item;

				// Add CSS class to it
				itemElement.addClass( 'item--error' );

				// Iterate each group of fields
				$.each( item.options, function( optionsGroupID, optionsGroupData ){

					// Check if a group of fields is invalid
					if ( ! optionsGroupData.isValid ){

						// Get DOM elements of the container with all the fields
						let optionsGroupElements = getDOMElements( 'optionGroup', {
							itemID: 	itemID,
							groupID: 	optionsGroupID
						});

						// Add error classes
						optionsGroupElements.tokenInSentence.addClass( 'item-title__token--error item-title__token--error-shake' );
						optionsGroupElements.fieldsContainer.addClass( 'item-options__group--error' );
						optionsGroupElements.optionsContainer.addClass( 'item-options--error' );

						// Remove "shake" class from tokenInSentence so the element can shake if the user clicks again
						setTimeout( function(){
							optionsGroupElements.tokenInSentence.removeClass( 'item-title__variable--error-shake' );
						}, 1000 );

						// Show errors in the UI for each invalid field
						if ( isDefined( optionsGroupElements.optionsContainer ) ){

							// Validate the form of the group of fields. Check validateItemFields comments for more information.
							validateItemFields( optionsGroupElements.optionsContainer );
						}
					}
				});
			}
		}
	}
	else {
		// ID is not defined, the item doesn't have an ID yet
		response.isValid = false;

		// Check if $item is defined 
		if ( ! isEmpty( $item ) ){
			
		}
		else {
			console.error( 'Neither itemID nor the $item are defined. One of them must be defined.' );	
		}
	}

	// Return response
	return response;
}

/**
 * Validate form using a DOM element that contains the fields
 * 
 * @since 0.1
 *
 * @param {object}	 form - jQuery DOM element that contains the fields
 *
 * @return {object}
 * @return {boolean}  response.isValid - TRUE if the form is valid
 */

export function validateItemFields( form, validateChildren = false ){
	// Create response object
	let response = {
		isValid: false
	}

	// Get all fields, input, textareas and selects
	let fields = form.find( `
		input.form-element__input[data-is-child-field="${ validateChildren ? 'true' : 'false' }"],
		textarea.form-element__textarea[data-is-child-field="${ validateChildren ? 'true' : 'false' }"],
		select.form-element__select[data-is-child-field="${ validateChildren ? 'true' : 'false' }"],
		.form-checkbox input,
		.form-radio` );

	// Set the variable that will be used to decide if the form is valid or not
	// It's true by default, but it will changed to false if at least one field has an error
	let isFormValid = true;

	// Go through all fields
	fields.each(function(){
		// Save $(this) jQuery element (from the each loop) in the field variable
		// form-element__input, form-element__textarea or form-element__select
		let field = $( this );

		// Get field type
		let fieldType = field.data( 'type' );

		// Define field data
		let fieldData = {}

		// Check if it's a radio
		if ( field.hasClass( 'form-radio' ) ){
			// Overwrite field type
			fieldType = 'radio';

			// Get one of the radios
			let radioInput     = field.find( 'input' ).first();

			// Get value of the selected radio (if there is any)
			let selectedRadio  = field.find( 'input:checked' ),
				radioValue     = selectedRadio.length > 0 ? selectedRadio.val() : '';

			// Create object with the data that will be used in the verification process
			fieldData = {
				field_type: 		 'radio',
				value: 				 radioValue,
				attributes: {
					supportsTokens:  radioInput.data( 'supportstokens' ),
					required: 		 radioInput.data( 'required' ),
				}
			}
		}
		// Check if it's a select
		else if ( field.hasClass( 'form-element__select' ) ){
			fieldData = {
				field_type: 		 'select',
				value: 				 field.val(),
				attributes: {
					supportsTokens:      field.data( 'supportstokens' ),
					required: 		     field.data( 'required' ),
					supportsCustomValue: field.data( 'supports-custom-value' ),
				}
			}
		}
		else {
			// Create object with the data that will be used in the verification process
			fieldData = {
				field_type: 		 field.data( 'type' ),
				value: 				 field.val(),
				attributes: {
					supportsTokens:  field.data( 'supportstokens' ),
					required: 		 field.data( 'required' ),
				}
			}

			// Check if it's a textarea, and check if it supports full-page editing
			if ( fieldData.field_type === 'textarea' ) {
				fieldData.attributes.supportsFullPageEditing = field.data( 'supportsfullpageediting' );
			}

			// Check if it's an int or float and has a min/max number defined
			if ( [ 'int', 'float' ].includes( fieldData.field_type ) ) {
				if ( ! isEmpty( field.data( 'min' ) ) && ! isNaN( parseFloat( field.data( 'min' ) ) ) ) {
					fieldData.attributes.minNumber = parseFloat( field.data( 'min' ) );
				}

				if ( ! isEmpty( field.data( 'max' ) ) && ! isNaN( parseFloat( field.data( 'max' ) ) ) ) {
					fieldData.attributes.maxNumber = parseFloat( field.data( 'max' ) );
				}
			}
		}

		// Check if it's a checkbox and overwrite the value
		if ( fieldData.field_type == 'checkbox' ){
			fieldData.value = field.is( ':checked' );
		}

		// Check if the field is required, the value is undefined but has a default value in the settings
		/*
		if ( fieldData.attributes.required && ! isDefined( fieldData.value ) && isDefined( fieldData.defaultValue ) ){
			// Set default value as value
			fieldData.value = fieldData.attributes.defaultValue;
		}
		*/

		// Validate form. Read validateField comments for more information
		let fieldValidation = validateField( field, fieldData.field_type, fieldData.value, fieldData.attributes );

		// Check if the field is invalid
		if ( ! fieldValidation.isValid ){
			isFormValid = false;

			// Add error class to form container
			form.addClass( 'item-options--error' );
		}
	});

	response.isValid = isFormValid;

	return response;
}

/**
 * Validates the value of a field.
 * Supports all field types
 *
 * Only supports one token. The object is prepared to support more than one, we only have to remove the if statement
 * that checks the number of tokens per string. This functionality will be change in another version
 *
 * @since 0.1
 *
 * @param {object} 		field - jQuery object of the field used to add CSS classes. Use null if you just want to get the validation response
 * @param {string} 		fieldType - A valid field type
 * @param {string} 		value - The value of the field.
 * @param {object}   	attributes - Object with some of the field attributes
 * @param {boolean} 	attributes.supportsTokens - TRUE if the field should support tokens
 * @param {boolean} 	attributes.required - TRUE if the field is required
 * @param {object} 		[customValidationFunction] Just in case you want to add a custom validation function. Must return an object with two properties { isValid: {boolean}, message: {string} }
 *
 * @return {object}
 * @return {boolean} 	response.isValid - TRUE if the field is valid
 * @return {string}  	response.message - Message showing the reason the field is invalid
 */

export function validateField( field, fieldType, value, attributes = { supportsTokens: false, required: false, supportsFullPageEditing: false }, customValidationFunction ){
	// Create response object
	let response = {
		isValid: false,
		message: '',
	}

	// Define valid field types
	let fieldTypes = validFieldTypes;

	// Set messages
	let messages = {
		select: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.select.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.select.invalid,
		},
		text: {
			empty:   UncannyAutomator._core.i18n.validation.field.text.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.text.invalid,
		},
		textarea: {
			empty:   UncannyAutomator._core.i18n.validation.field.textarea.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.textarea.invalid,
		},
		int: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.int.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.int.invalid,
			multipleTokens: UncannyAutomator._core.i18n.validation.field.int.multipleTokens,
			minValue: UncannyAutomator._core.i18n.validation.field.int.minValue,
			maxValue: UncannyAutomator._core.i18n.validation.field.int.maxValue,
		},
		float: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.float.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.float.invalid,
			multipleTokens: UncannyAutomator._core.i18n.validation.field.float.multipleTokens,
			minValue: UncannyAutomator._core.i18n.validation.field.float.minValue,
			maxValue: UncannyAutomator._core.i18n.validation.field.float.maxValue,
		},
		email: {
			empty:   UncannyAutomator._core.i18n.validation.field.email.empty,
			single:  {
				invalid: UncannyAutomator._core.i18n.validation.field.email.single.invalid,
				multipleTokens: UncannyAutomator._core.i18n.validation.field.email.single.multipleTokens,
			},
			multiple: {
				invalid: UncannyAutomator._core.i18n.validation.field.email.multiple.invalid,
				multipleTokens: UncannyAutomator._core.i18n.validation.field.email.multiple.multipleTokens,
			}	
		},
		url: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.url.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.url.invalid,
		},
		checkbox: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.checkbox.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.checkbox.invalid,
		},
		radio: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.radio.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.radio.invalid,
		},
		date: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.date.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.date.invalid,
		},
		time: {
			empty: 	 UncannyAutomator._core.i18n.validation.field.time.empty,
			invalid: UncannyAutomator._core.i18n.validation.field.time.invalid,
		},
		invalidType: UncannyAutomator._core.i18n.validation.field.invalidType,
	}

	// Fix TinyMCE issue, where adding content dynamically doesn't update the textarea value
	try {
		if ( fieldType == 'textarea' && ! isEmpty( field ) && field.is( ':not(:visible)' ) ){
			let $formElement = field.closest( '.form-element' );

			$formElement.find( '.switch-html' )
				.trigger( 'click' );

			value = field.val();

			$formElement.find( '.switch-tmce' )
				.trigger( 'click' );

		}
	} catch ( e ){
		// Continue regardless of error
		
		// Output error if the developer mode is enabled
		if ( UncannyAutomator._site.has_debug_enabled ){
			// eslint-disable-next-line no-console
			console.warn( e );
		}
	}

	// Check if it's a valid field type
	if ( inArray( fieldType, fieldTypes ) ){
		// Check if it's a checkbox and sanitaze the current value
		if ( fieldType == 'checkbox' && ! isEmpty( value ) ){
			// Check if the value is "true" or "false"
			if ( [ 'true', 'false' ].includes( value ) ){
				// Make it a boolean
				value = value == 'true' ? true : false;
			}
		}

		// Check if it's a required field and it's empty.
		// Show "empty" error
		if ( attributes.required && ( isEmpty( value ) || fieldType == 'checkbox' && value === false ) ){
			response.message = messages[ fieldType ].empty;
		}
		// Check if it isn't a required field and it's empty.
		// We don't have to validate it
		else if ( ! attributes.required && isEmpty( value ) ){
			response.isValid = true;
		}
		// The field has a value
		else if ( value != '' ){
			// This variable will be used multiple times in the following code. Let's define it here.
			let tokensInString;

			// Check what's our field type.
			switch ( fieldType ){

				case 'select':
					response.isValid = true; 

					// Check if the value is a custom value, if so, validate it
					if ( attributes.supportsCustomValue && value == 'automator_custom_value' ){
						// Get the child field
						const $childrenFields = field.closest( '.form-element' ).find( '.form-element-children' );

						// Check if we found it
						if ( $childrenFields.length == 1 ){
							// Validate it and pass the result to the parent
							response.isValid = validateItemFields( $childrenFields, true ).isValid;
						}
					}

					// Check if we have to do a custom validation
					if ( response.isValid && isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'text':
				case 'textarea':
					response.isValid = true;

					// If it's a 1. [required] 2. [textarea] that 3. [suppors full-page editing], make sure it really has content
					// Because the field adds an HTML structure by default that makes it impossible for the JS to detect if it's empty
					if (
						// 1. [required]
						attributes.required &&
						// 2. [textarea]
						fieldType === 'textarea' &&
						// 3. [supports full-page editing]
						attributes.supportsFullPageEditing
					) {
						// Create a temporary element where we're going to add the value, to then remove the HTML
						const $tempWrapper = document.createElement( 'div' );
						$tempWrapper.innerHTML = value;

						// Get the field value, without HTML and spaces
						const fieldValueNoHTML = $tempWrapper.innerText.trim();
						
						if ( isEmpty( fieldValueNoHTML ) ) {
							response.isValid = false;
							response.message = messages[ fieldType ].empty;

							// Stop here
							break;
						}
					}

					// Check if we have to do a custom validation
					if ( isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'int':
					// Regular expression to check if it's a valid int number
					// https://regex101.com/r/Gz3RvN/4
					let int_regex = new RegExp(/^([+-]?[1-9]\d*|0)$/gm);

					// Get tokens. Read getTokensFromString comments for more information
					tokensInString = getTokensFromString( value );

					// Create variable to simulate int (replace tokens)
					let simulate_int;

					// Check if the string has tokens (and if it should support them)
					if ( attributes.supportsTokens && tokensInString.length > 0 ){
						// Check if the string has only one token. As we said before, this can be easily changed in future versions
						if ( tokensInString.length == 1 ){
							// If it has ONE token, and the field support it, then let's just make the data valid
							response.isValid = true;
						}
						else {
							// We only support one token for now. Show multiple tokens error.
							response.message = messages.int.multipleTokens;
						}
					}
					else {
						// Doesn't have tokens, so we only have to perform the regular expression test
						if ( int_regex.test( value ) ){
							response.isValid = true;
						}
						else {
							// Show "invalid" message
							response.message = messages.int.invalid;
						}

						// Convert the value to integer
						value = parseInt( value );

						// Determine if a minimum value has been defined, and if so, determine if the value is less than the minimum
						if ( ! isEmpty( attributes.minNumber ) && value < parseFloat( attributes.minNumber ) ) {
							response.isValid = false;
							response.message = sprintf( messages.int.minValue, attributes.minNumber );
						}

						// Determine if a maximum value has been defined, and if so, determine if the value is more than the maximum
						if ( ! isEmpty( attributes.maxNumber ) && value > parseFloat( attributes.maxNumber ) ) {
							response.isValid = false;
							response.message = sprintf( messages.int.maxValue, attributes.maxNumber );
						}
					}

					// Custom validation. Check if it's valid, if it isn't then do nothing
					// Check if we have to do a custom validation
					if ( response.isValid && isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value, simulate_int );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'float':
					// Regular expression to check if it's a valid float number
					// https://regex101.com/r/KDLmre/2/
					let float_regex = new RegExp(/^[+-]?((\d+(\.|\,)?\d*)|(\.\d+))$/gm);

					// Get tokens. Read getTokensFromString comments for more information
					tokensInString = getTokensFromString( value );

					// Create variable to simulate the float (replace tokens)
					let simulate_float;

					// Check if the string has tokens (and if it should support them)
					if ( attributes.supportsTokens && tokensInString.length > 0 ){
						// Check if the string has only one token. As we said before, this can be easily changed in future versions
						if ( tokensInString.length == 1 ){
							// If it has ONE token, and the field support it, then let's just make the data valid
							response.isValid = true;
						}
						else {
							// We only support one token for now. Show multiple tokens error.
							response.message = messages.float.multipleTokens;
						}
					}
					else {
						// Doesn't have tokens, so we only have to perform the regular expression test
						if ( float_regex.test( value ) ){
							response.isValid = true;
						}
						else {
							// Show "invalid" message
							response.message = messages.float.invalid;
						}

						value = parseFloat( value );

						// Determine if a minimum value has been defined, and if so, determine if the value is less than the minimum
						if ( ! isEmpty( attributes.minNumber ) && value < parseFloat( attributes.minNumber ) ) {
							response.isValid = false;
							response.message = sprintf( messages.int.minValue, attributes.minNumber );
						}

						// Determine if a maximum value has been defined, and if so, determine if the value is more than the maximum
						if ( ! isEmpty( attributes.maxNumber ) && value > parseFloat( attributes.maxNumber ) ) {
							response.isValid = false;
							response.message = sprintf( messages.int.maxValue, attributes.maxNumber );
						}
					}

					// Custom validation. Check if it's valid, if it isn't then do nothing
					// Check if we have to do a custom validation
					if ( response.isValid && isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value, simulate_float );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'email':
					// Regular expression to check if it's a valid email address
					// https://regex101.com/r/ThUWEz/1/
					let email_regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

					// Create array with all the emails we have to validate
					// We're going to check if the user is trying to validate more than one searching for a comma in the input value
					// In that case, we're going to split the value and get an array with emails, otherwise we're going to create an array with one element: the input value
					// Doing that we can use the same code for both cases
					let emails = [];

					// Check if the user wants to validate multiple emails
					if ( value.includes( ',' ) ){
						emails = value.split( ',' );

						// Remove whitespace from both sides of each email, just in case the user wrote ", " or " ," instead of ","
						$.each( emails, function( index, email ){
							emails[ index ] = email.trim();
						});
					}
					else {
						// Add value, but remove whitespace from both sides before
						emails.push( value.trim() );
					}

					// Get tokens. Read getTokensFromString comments for more information
					tokensInString = getTokensFromString( value );

					// Create variable to simulate the email (replace tokens)
					let simulate_email;
					
					// We're going to use this variable to validate all the emails in a loop. TRUE by default, FALSE if at least one of them fails.
					let allEmailsAreValid = true;

					// Create variable used to know if there is more than one email
					let hasMultipleEmails = emails.length > 1;

					// Check if the string has tokens
					if ( attributes.supportsTokens && tokensInString.length > 0 ){
						// Create variable to check if the error was due to multiple variables
						let hasMultipleVariables = false;

						// Iterate each email
						$.each( emails, function( index, email ){
							// Get tokens from this specific email
							tokensInString = getTokensFromString( email );

							// Check if the string has only one token. As we said before, this can be easily changed in future versions
							if ( tokensInString.length <= 1 ){
								// If it has ONE token, and the field support it, then let's just make the data valid
								// In this case, we have to do nothing
							}
							else {
								// Change value of hasMultipleVariables. We're going to use this to show a "Multiple Tokens" error
								hasMultipleVariables = true;

								// Return false, we don't have to continue checking
								return false;
							}
						});

						// Check result of iteration
						if ( allEmailsAreValid && ! hasMultipleVariables ){
							response.isValid = true;
						}
						else {
							if ( hasMultipleVariables ){
								// We only support one token for now. Show multiple tokens error.
								if ( hasMultipleEmails ){
									response.message = messages.email.multiple.multipleTokens;
								}
								else {
									response.message = messages.email.single.multipleTokens;
								}
							}
							else {
								// Show "invalid" message
								if ( hasMultipleEmails ){
									response.message = messages.email.multiple.invalid;
								}
								else {
									response.message = messages.email.single.invalid;
								}
							}
						}
					}
					else {
						// Doesn't have tokens, so we only have to perform the regular expression test in each email
						$.each( emails, function( index, email ){
							// Do regex
							if ( ! email_regex.test( email ) ){
								// If one is valid, all are invalid
								allEmailsAreValid = false;
							}
						});

						// Check result of iteration
						if ( allEmailsAreValid ){
							response.isValid = true;
						}
						else {
							// Show "invalid" message
							if ( hasMultipleEmails ){
								response.message = messages.email.multiple.invalid;
							}
							else {
								response.message = messages.email.single.invalid;
							}
						}
					}

					// Custom validation. Check if it's valid, if it isn't then do nothing
					// Check if we have to do a custom validation
					if ( response.isValid && isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value, simulate_email );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'url':
					// Make the URL valid
					response.isValid = true;

					// Custom validation. Check if it's valid, if it isn't then do nothing
					// Check if we have to do a custom validation
					if ( response.isValid && isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'checkbox':
					response.isValid = true;

					// Check if we have to do a custom validation
					if ( isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'radio':
					response.isValid = true;

					// Check if we have to do a custom validation
					if ( isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;
				
				case 'date':
					response.isValid = true;

					// Check if we have to do a custom validation
					if ( isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				case 'time':
					response.isValid = true;

					// Check if we have to do a custom validation
					if ( isDefined( customValidationFunction ) ){
						// Do custom validation
						let customValidation = customValidationFunction( value );
						// Check if it's valid
						response.isValid = customValidation.isValid;

						// If it isn't then add message
						if ( ! customValidation.isValid ){
							response.message = customValidation.message;
						}
					}

					break;

				default:
					// The field type doesn't match
					response.isValid = false;
					response.message = '';
					break;
			}
		}
	}
	else {
		response.message = messages[ 'invalidType' ];
	}

	// Add CSS classes to elements showing or hiding the error state
	// .form-element will have form-element--success or form-element--error classes
	// The message will be shown in the .form-element__error element
	if ( ! isEmpty( field ) ){
		let $container = field.closest( '.form-element' );
		let $error_container = $container.find( '.form-element__error' ).filter(function(){
			return $( this ).closest( '.form-element' ).is( $container );
		});

		if ( ! response.isValid ){
			$container.removeClass( 'form-element--success' );
			$container.addClass( 'form-element--error' );
		}
		else {
			$container.removeClass( 'form-element--error' );
			$container.addClass( 'form-element--success' );
		}

		if ( response.message != '' ){
			$error_container.addClass( 'form-element__error--show' );
			$error_container.text( response.message );
		}
		else {
			$error_container.removeClass( 'form-element__error--show' );
			$error_container.text('');
		}

	}

	return response;
}

/**
 * Gets all tokens from a value.
 *
 * @param {Any} value - The value to extract tokens from.
 * @returns {Array} - An array of all tokens found in the value.
 */
export function getTokensFromString( value ) {
    const regex = new RegExp( /\{\{(.*?)\}\}/gm );
    const matches = String( value ).match( regex );
    return matches || [];
}